// extracted by mini-css-extract-plugin
export default {"prayer-page":"prayer-page--bfU13","prayerPage":"prayer-page--bfU13","back-link":"back-link--Jcklm","backLink":"back-link--Jcklm"};